module.exports = __webpack_public_path__ + "img/HZ-S4040.f5cc5d1b.jpg";